import { Icon } from '@iconify/react';
import _ from 'lodash';
import { useEffect, useState } from 'react';
import { Col } from "react-bootstrap";
import { useQuery } from 'react-query';
import { ClipLoader } from 'react-spinners';
import { suggestEquipmentUnitClassById, updateEquipmentUnitInfo } from '../../../api';
import { checkForAPISuccess, showErrorToast, showSuccessToast } from '../../../Common/commonFunctions';
import { useDispatch, useSelector } from 'react-redux';
import { SET_ONGOING_EDIT_GLOBALLY, UPDATE_EQUIPMENT_UNIT_CLASS } from '../../../store/actions';

const EquipmentUnitClass = props => {

    const CANCEL = "CANCEL", EDIT = "EDIT", SAVE = "SAVE";
    const dispatch = useDispatch();
    const isEditOngoing = useSelector(store => store.equipment.isEditOngoing);
    const isLockedProfile = useSelector(store => store.equipment.isLockedProfile);
    const equipmentUnitClasses = useSelector(store => store.equipment.equipmentUnitClasses);
    const [utils, setUtils] = useState({ class: "", isEditActive: false, suggestedClass: "" });
    const useQueryConfiguration = {
        enabled: false, retry: false, retryOnMount: false,
        refetchOnMount: false, refetchOnWindowFocus: false
    }
    
    const fetchClassSuggestion = async () => {
        const response = await suggestEquipmentUnitClassById(props.id);
        return response?.data;
    }

    const updateClassSuggestion = async () => {
        const response = await updateEquipmentUnitInfo(props.id, { "class": utils.class });
        return response?.data;
    }

    const fetchClassSuggestionQuery =  useQuery(`class-suggestion-${props.id}`, fetchClassSuggestion, { ...useQueryConfiguration });

    const updateClassQuery =  useQuery(`update-class-${props.id}`, updateClassSuggestion, { ...useQueryConfiguration });

    const returnIcon = (icon, className, callBack) => 
        <Icon icon={icon} className={className} width={20} height={20} onClick={() => callBack()} />

    const handleIcons = (action) => {
        if(action === CANCEL) {
            dispatch({ type: SET_ONGOING_EDIT_GLOBALLY, payload: false });
            setUtils({ ...utils, isEditActive: false, class: "" });
        }
        else if(action === EDIT) {
            dispatch({ type: SET_ONGOING_EDIT_GLOBALLY, payload: true });
            setUtils({ ...utils, isEditActive: true });
            fetchClassSuggestionQuery.refetch();
        }
        else {
            updateClassQuery.refetch();
        }
    }

    useEffect(() => {
        if(fetchClassSuggestionQuery.isFetched) {
            if(fetchClassSuggestionQuery.isSuccess && checkForAPISuccess(fetchClassSuggestionQuery?.data?.statusCode)) {
                setUtils({ ...utils, suggestedClass: fetchClassSuggestionQuery?.data?.data });
            }
            else {
                setUtils({ ...utils, suggestedClass: "Failed to get suggestion" });
            }
            fetchClassSuggestionQuery.remove();
        }
    }, [fetchClassSuggestionQuery.isFetched]);

    useEffect(() => {
        if(updateClassQuery.isFetched) {
            if(updateClassQuery.isSuccess && checkForAPISuccess(updateClassQuery?.data?.statusCode)) {
                showSuccessToast("Updated equipment unit class successfully");
                dispatch({ type: UPDATE_EQUIPMENT_UNIT_CLASS, payload: { name: props.name, class: utils.class } });
            }
            else {
                showErrorToast("Failed to update equipment unit class");
            }
            dispatch({ type: SET_ONGOING_EDIT_GLOBALLY, payload: false });
            updateClassQuery.remove();
        }
    }, [updateClassQuery.isFetched]);

    useEffect(() => {
        setUtils({ class: "", suggestedClass: "", isEditActive: false });
    }, [props.class]);

    return (
        <div className="border-bottom-secondary">
            {
                fetchClassSuggestionQuery.isFetching || updateClassQuery.isFetching ?
                    <Col md={{ span: 12 }} className='equipment-unit-field-loader my-1'>
                        <ClipLoader color='#075978' size={25} />
                    </Col>
                        :
                    <div className='equipment-unit-field-container py-1'>
                        <div className='ml-2 w-50'>
                            Class
                        </div>
                        <div className='mr-2 w-50 justify-end'>
                            {
                                utils.isEditActive ?
                                    <div className='h-100 w-75'>
                                        <div className='justify-end'>
                                            <select
                                                onChange={(e) => setUtils({ ...utils, class: e.target.value })}
                                                defaultValue={!_.isEmpty(props.class) ? props.class : "default"}
                                                className="edit-dropdown h-100 text-left mr-2"
                                            >
                                                <option disabled value={"default"}>Select</option>
                                                {
                                                    !_.isEmpty(equipmentUnitClasses) &&
                                                        equipmentUnitClasses.map(eqpUnitClass =>
                                                            <option
                                                                value={eqpUnitClass.name}
                                                                key={eqpUnitClass.id}
                                                            >
                                                                    {eqpUnitClass.name}
                                                            </option>
                                                        )
                                                }
                                            </select>
                                            {
                                                !_.isEmpty(utils.class) && (utils.class !== props.class) &&
                                                <div>
                                                    {returnIcon("feather-check", "cursor-pointer", () => handleIcons(SAVE))}
                                                </div>
                                            }
                                            <div>
                                                {returnIcon("feather-x", "text-color-grey cursor-pointer", () => handleIcons(CANCEL))}
                                            </div>
                                        </div>
                                        {
                                            !fetchClassSuggestionQuery.isFetching &&
                                                <div className='equipment-unit-field-suggestion'>
                                                    {utils.isEditActive && `Suggestion: ${utils.suggestedClass}`}
                                                </div>
                                        }
                                    </div>
                                        :
                                    <>
                                        <div className={"mr-2"}>
                                            {!_.isEmpty(props.class) ? props.class : "-"}
                                        </div>
                                        {
                                            !isLockedProfile &&
                                                returnIcon("feather-edit", isEditOngoing ? "disable-click text-color-grey" : "cursor-pointer", () => handleIcons(EDIT))
                                        }
                                    </>
                            }
                        </div>
                    </div>
            }
        </div>
    );
}

export default EquipmentUnitClass;